<template>
    <div
        class="svg-inline-container"
        v-html="svgSrc"
    />
</template>
<style>
.svg-inline-container {
    display: inline-block;
}

.svg-inline {
    @apply mx-auto;
    overflow: visible !important;
    fill: currentColor;
    height: 100%;
    margin-top: -4px;
    vertical-align: middle;
    width: 100%;
}
</style>

<script>

export default {
    props: {
        src: {
            type: String,
            required: true
        },
        id: null
    },
    computed: {
        svgSrc() {
            let svgPath = `${this.src}`;
            try {
                // If the src does not have svg extension, add
                if (!this.src.endsWith('.svg')) {
                    svgPath = `${svgPath}.svg`;
                }
                // eslint-disable-next-line global-require, import/no-dynamic-require
                return require(`!svg-inline-loader!@/assets/svg/${svgPath}`);
                // return require(`!!html-loader!@/assets/${svgPath}`);
            } catch (e) {
                console.warn('No svg file found for ', this.src, svgPath);
            }
            return `<img src="${svgPath}" alt="${svgPath}" title"SVG Not found" />`;
        }
    },
    async mounted() {
        await this.$nextTick();
        const svg = this.$el.querySelector('svg');
        if (!svg) {
            console.warn('SVG src does not contain an svg element', this.src, this.$el);
            return;
        }
        d3.select(svg)
            .classed('svg-inline', true)
            .attr('height', null)
            .attr('width', null);
        d3.select(svg).select('title').remove();
        // TODO: Remove desc, def, style
        // TODO: Add class as well as id
        // TODO: Add viewbox if not there, with width/height if they were there
        if (this.id) {
            d3.select(svg)
                .attr('id', this.id);
            // svg.setAttribute('id', this.id);
        }
    }

};
</script>
